import axios from '@/common/axios'
import API from '@/config/apis'

// 请求banner图
export function getBanner(params) {

	return new Promise(function(resolve, reject){
		axios('post', API.PROFILE.BANNER,params)
			.then(function (result) {
				resolve(result.data)
			})
	})
}

// 提交解决方案
export function submitSolution(params) {

	return new Promise(function(resolve, reject){
		axios('post', API.SOLUTION.TO_SUBMIT, params)
			.then(function (result) {
				resolve(result)
			})
	})

}

// 请求产品列表 此处是需求发生变更后新增的请求
export function getList(params) {

    return new Promise(function(resolve, reject){
        axios('post', API.PRODUCT.GETLIST, params)
            .then(function (result) {
                resolve(result.data)
            })
    })

}

// 请求产品列表
export function getProductList(params) {

	return new Promise(function(resolve, reject){
		axios('post', API.PRODUCT.LIST, params)
			.then(function (result) {
				resolve(result.data)
			})
	})

}

// 请求产品搜索热词
export function getHotWords() {

	return new Promise(function(resolve, reject){
		axios('post', API.PRODUCT.HOT)
			.then(function (result) {
				resolve(result.data)
			})
	})

}

// 请求产品详情
export function getProductDetails(params) {

	return new Promise(function(resolve, reject){
		axios('post', API.PRODUCT.DETAILS, params)
			.then(function (result) {
				resolve(result.data)
			})
	})

}

// 产品详情记录
export function addRecord(params) {

    return new Promise(function(resolve, reject){
        axios('post', API.PRODUCT.ADD, params)
            .then(function (result) {
                resolve(result.data)
            })
    })

}

// 请求产品详情图片
export function getProductImg(params) {

	return new Promise(function(resolve, reject){
		axios('post', API.PRODUCT.IMG, params)
			.then(function (result) {
				resolve(result.data)
			})
	})

}

// 请求客服
export function fetchAnswer(params) {

    return new Promise(function(resolve, reject){
        axios('post', API.PROFILE.QUESTION, params)
            .then(function (result) {
                resolve(result.data)
            })
    })

}